import * as React from 'react';

import { renderRoutes } from 'react-router-config';
import { throttle } from 'throttle-debounce';

import { isMobileScreen } from '@base/utils';

import { CatalogTabs, OuterWrapper } from '@ui';

import { IAppsCatalogProps } from './types';

import * as s from './AppsCatalog.scss';

export const AppsCatalog: React.FC<IAppsCatalogProps> = (props: IAppsCatalogProps) => {
	const [showCatalogTabs, setShowCatalogTabs] = React.useState(true);

	React.useEffect(() => {
		setShowCatalogTabs(!isMobileScreen());
	}, []);

	React.useEffect(() => {
		const onResize = throttle(300, () => {
			setShowCatalogTabs(!isMobileScreen());
		});

		window.addEventListener('resize', onResize);
		return () => {
			window.removeEventListener('resize', onResize);
		};
	}, []);

	return (
		<OuterWrapper className={s.block}>
			{showCatalogTabs && <CatalogTabs className={s.tabs}/>}
			{renderRoutes(props.route.routes)}
		</OuterWrapper>
	);
};
